import React from 'react';
import PropTypes from 'prop-types';
import ImageLoad from 'components/ImageLoad';
import style from './style.scss';//NOSONAR
import { ecommerce } from 'config/constants';

const Video = (props) => {

    const item = props.item ? props.item : null;
    const imageMobile = item ? item.image_mobile : '';
    const imageDesktop = item ? item.image_desktop : '';

    const imageResponsive = {
        839: imageMobile ? imageMobile : '',
        1440: imageDesktop ? imageDesktop : ''
    };

    const _getVideo = (idVideo, play = false) => {
        const autoPlay = play ? '1' : '0';
        return `https://www.youtube.com/embed/${idVideo}?autoplay=${autoPlay}`;
    }

    return (
        <>
            {(item && item.url_video === '') ? <ImageLoad src={imageMobile ? imageMobile : ''} srcSet={imageResponsive} className="banner-categories-imagen"/> : <div className={'video-recipe-wrapper'} >
                <div className="video-iframe-recipe-container">
                    <iframe src={_getVideo((item && item.url_video), (item && item.autoplay))} 
                        frameBorder='0'
                        className="video-iframe"
                        allow='autoplay; encrypted-media'
                        allowFullScreen
                        title={ecommerce.metaTitle}
                    />
                </div> 
            </div>}

        </>
    )
}

Video.propTypes = {
    item: PropTypes.object
};

export default Video;